/**
 * Haulier: more in the bag.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const HAULIER = {
  id: 'haulier',
  branch: 'scavenging',
  tier: 2,
  title: 'Haulier',
  blurb: 'Certified to move goods between sites. The sites are gone. The certificate is not.',
  maxRanks: 2,
  minLevel: 9,
  requires: ['strongBack'],
  statGrants: {},
  effects: [{ field: 'carryKg', perRank: 0.07, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
